import AssessmentSectionRating from '@app/src/components/AssessmentSectionRating'
import type Assessment from '@app/src/types/assessment'
import { Stack, Typography } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'
import { getSectionLevel, getTemplateSections } from './assessmentAnswersLogic'

interface AssessmentSectionRatingsProps {
  assessment: Assessment
}

const AssessmentSectionRatings: React.FC<AssessmentSectionRatingsProps> = ({ assessment }) => {
  const { formatMessage } = useIntl()
  const sections = getTemplateSections(assessment)

  if (sections.length === 0) return null

  return (
    <Stack width="100%" spacing={1}>
      <Typography variant="subtitle1">{formatMessage({ id: 'baselineAssessment.sectionAssessment' })}</Typography>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        justifyContent="space-between"
        spacing={{ xs: 2, sm: 0 }}
        flexWrap="wrap"
        useFlexGap
      >
        {sections.map(section => (
          <AssessmentSectionRating
            key={section.id}
            sectionName={section.name}
            level={getSectionLevel(assessment, section.assessmentSectionNumber)}
            totalLevels={assessment.assessmentTemplate.levels}
          />
        ))}
      </Stack>
    </Stack>
  )
}

export default AssessmentSectionRatings
